// extracted by mini-css-extract-plugin
export var date = "latestNews-module--date--8954e";
export var item = "latestNews-module--item--24015";
export var more = "latestNews-module--more--4afb8";
export var news = "latestNews-module--news--eaa2d";
export var previewTitle = "latestNews-module--previewTitle--461cb";
export var text = "latestNews-module--text--89967";
export var title = "latestNews-module--title--acfb5";